import { Label } from "@/components/ui/label";
import { handleFormChange } from "@/utils/formChange";
import { FC, FormEvent, useRef } from "react";
import { formInterface } from "@/interface/dataInterface";
import StaticDataSelect from "@/components/input/StaticDataSelect";
import AutocompleteLocation from "../dispatch/components/AutocompleteLocation";
import { BaseInput } from "@/components/input/CustomInputs";

const FixedRouteForm: FC<formInterface> = ({
  formProp,
  setFormProp,
  otherData,
  setOtherData,
}) => {
  const pickupRef = useRef<HTMLInputElement | null>(null);
  const dropoffRef = useRef<HTMLInputElement | null>(null);

  return (
    <div className="grid grid-cols-2 place-items-center gap-4">
      <div className="w-full">
        <AutocompleteLocation
          placeholder="Origin"
          selectedLocation={otherData?.origin}
          location={(data: any) => {
            setOtherData ? setOtherData(data, "origin") : {};
          }}
          inputRef={pickupRef}
        />
      </div>
      <div className="w-full">
        <AutocompleteLocation
          placeholder="Destination"
          selectedLocation={otherData?.destination}
          location={(data: any) =>
            setOtherData ? setOtherData(data, "destination") : {}
          }
          inputRef={dropoffRef}
        />
      </div>
      <BaseInput
        id="price"
        label="Price"
        type="number"
        value={formProp.price}
        setProp={setFormProp}
        placeholder="Price"
      />
      <div className="w-full">
        <Label htmlFor="currency">Currency *</Label>
        <StaticDataSelect
          id="currency"
          value={formProp.currency}
          setValue={(e: FormEvent<HTMLSelectElement>) =>
            handleFormChange(e, setFormProp)
          }
          data={[{label: "ALL"}, {label: "EUR"}, {label: "USD"}, {label: "GPB"}]}
        />
      </div>
    </div>
  );
};

export default FixedRouteForm;
